// extracted by mini-css-extract-plugin
export var active = "_q-9";
export var backButton = "_q-8";
export var clone = "_q-e";
export var collapseBar = "_q-k";
export var collapseMode = "_q-m";
export var collapsed = "_q-o";
export var dimmed = "_q-i";
export var dragHandle = "_q-c";
export var dropdownIcon = "_q-g";
export var expanding = "_q-n";
export var hidden = "_q-x";
export var iconContainer = "_q-q";
export var iconSwapper = "_q-w";
export var navItem = "_q-6";
export var navItemIcon = "_q-f";
export var navProfile = "_q-7";
export var notificationCountBadge = "_q-j";
export var notificationDot = "_q-r";
export var optionsContainer = "_q-h";
export var primaryNav = "_q-0";
export var primaryNavDivider = "_q-v";
export var primaryNavResizeHandle = "_q-2";
export var primaryNavResizing = "_q-1";
export var primaryNavTabSection = "_q-u";
export var primaryTab = "_q-p";
export var primaryTabIconBox = "_q-s";
export var secondaryNav = "_q-3";
export var selected = "_q-t";
export var settingsNav = "_q-4";
export var settingsNavItems = "_q-5";
export var show = "_q-d";
export var sideNav = "_q-l";
export var teamItem = "_q-a";
export var userProfileItem = "_q-b";